import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { ShieldCheck, ArrowRight } from 'lucide-react';

const AutonomieActionCard = ({ linkTo = '/validation-autonomie' }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    loadCount();
    const interval = setInterval(loadCount, 300000);
    return () => clearInterval(interval);
  }, []);

  const loadCount = async () => {
    try {
      const response = await axios.get('/autonomies/pending-count');
      setCount(response.data?.count || 0);
    } catch (error) {
      // Silently fail
    }
  };

  if (count > 0) {
    return (
      <Link
        to={linkTo}
        className="bg-gradient-to-br from-amber-500 to-orange-500 border-0 rounded-lg p-6 shadow-lg hover:shadow-xl hover:scale-[1.02] transition-all block relative overflow-hidden"
        data-testid="action-autonomie"
      >
        <div className="absolute top-0 right-0 w-20 h-20 bg-white/10 rounded-full -translate-y-6 translate-x-6" />
        <div className="flex items-center space-x-4 relative z-10">
          <div className="relative p-3 rounded-lg bg-white/20">
            <ShieldCheck className="h-6 w-6 text-white" />
            <span className="absolute -top-2 -right-2 bg-white text-amber-600 text-xs font-bold rounded-full shadow-lg flex items-center justify-center w-6 h-6 animate-bounce">
              {count}
            </span>
          </div>
          <div className="flex-1">
            <p className="text-lg font-bold text-white">
              Valider l'autonomie
            </p>
            <p className="text-sm text-white/80 font-medium">
              {count} validation{count > 1 ? 's' : ''} en attente
            </p>
          </div>
          <ArrowRight className="h-5 w-5 text-white/80" />
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={linkTo}
      className="bg-white border border-slate-200 rounded-lg p-6 shadow-sm border-l-4 border-l-slate-400 hover:shadow-md transition-shadow block"
      data-testid="action-autonomie"
    >
      <div className="flex items-center space-x-4">
        <div className="p-3 rounded-lg bg-slate-100">
          <ShieldCheck className="h-6 w-6 text-slate-500" />
        </div>
        <div>
          <p className="text-lg font-semibold text-[#0F172A]">Valider Autonomie</p>
          <p className="text-sm text-slate-600">Aucune en attente</p>
        </div>
      </div>
    </Link>
  );
};

export default AutonomieActionCard;
